export enum AuthType {
  Otp = 'otp',
  DepositSign = 'depositSign',
  LoginPassword = 'loginPassword',
}
